/**
 * @description Hook utilizado para manipular os permissões
 * @author Diego Sabino Amorim de Araújo
 * @file usePermissaoService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useFetch } from './useFetch'

export const usePermissaoService = () => {
  const fetch = useFetch()

  const listarPermissoesAsync = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`permissoes`)
      return response.data.permissoes
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return { listarPermissoesAsync }
}
